module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/mtorn2-8a88b114e0aeb1ddfefa24d934d369a8.jpg";